import { optionPrices } from './apiclients/optionprices';
import { pricingOptions } from './apiclients/pricingoptions';
import { vehicleDetails } from './apiclients/vehicledetails';
import { technical } from './apiclients/technical';
import { pricing } from './apiclients/pricing';
import { clientConfig } from './clientconfig';
import { validateOptions } from './apiclients/validateoptions';
export const apiClient = (config) => {
    const apiConfig = clientConfig(config);
    return {
        getOptionPrices: optionPrices(apiConfig).getOptionPrices,
        getPricingOptions: pricingOptions(apiConfig).getPricingOptions,
        getVehicleDetails: vehicleDetails(apiConfig).getVehicleDetails,
        getVehicleTechnical: technical(apiConfig).getVehicleTechnical,
        getVehiclePricing: pricing(apiConfig).getVehiclePricing,
        getValidateOptions: validateOptions(apiConfig).getValidateOptions,
    };
};
